import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { LumenDiagnosticsComponent } from './lumen-diagnostics.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule
    ],
    declarations: [
        LumenDiagnosticsComponent
    ],
    providers: [],
    exports: []
})
export class LumenDiagnosticsModule {}
